<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="cardSupplierData === null">Create Card Supplier</span>
      <span v-else>Update Card Supplier</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Code" required>
              <a-input
                v-model.trim="$v.formData.code.$model"
                :disabled="viewMode || cardSupplierData !== null"
                @input="formData.code = $event.target.value.toUpperCase()"
              />
              <div v-if="$v.formData.code.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.code.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Name" required>
              <a-input
                v-model.trim="$v.formData.name.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.name.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.name.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Status">
              <a-select v-model="formData.status" :disabled="viewMode">
                <a-select-option value="A"> Active </a-select-option>
                <a-select-option value="I"> Inactive </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="cardSupplierData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createCardSupplier"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="updateCardSupplier"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';

export default {
  name: 'CardSupplierForm',
  props: {
    cardSupplierData: Object,
    viewMode: Boolean
  },

  data() {
    return {
      formSubmitting: false,
      formData: {
        code: null,
        name: null,
        status: 'A'
      }
    };
  },

  validations: {
    formData: {
      code: { required },
      name: { required }
    }
  },

  methods: {
    async createCardSupplier() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;

        const response = await HTTPRequest.postRequest(
          '/api/v1/card_suppliers',
          {
            card_supplier: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    async updateCardSupplier() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/card_suppliers/' + this.cardSupplierData.id,
          {
            card_supplier: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },

    clearForm() {
      this.formData = {
        code: null,
        name: null,
        status: 'A'
      };
    },

    setFormData(data) {
      if (this.cardSupplierData !== null) {
        const { code, name, status } = data;

        this.formData = {
          code,
          name,
          status
        };
      }
    }
  },

  created: async function () {
    this.setFormData(this.cardSupplierData);
  },

  watch: {
    cardSupplierData: function (data) {
      if (data !== null) {
        this.setFormData(data);
      } else {
        this.clearForm();
      }
    }
  }
};
</script>

<style scoped></style>
